import React, { Component } from 'react';
import { withDomains ,RESTExecutor} from '../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../lib/util';
import { Select, Input, Divider, Row, Checkbox, Button, message, Tag, InputNumber } from 'antd';
import Form from '../../lib/ui/form';
import Title from 'antd/lib/typography/Title';


class ReportActionsAddEdit extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            form_data: this.props.data || {},
            edit_id: this.props.action_id,
            config_id:this.props.config_id,
            actions: {},
            actionSchema: []
          }

          this.list_actions = RESTExecutor.list().config({
            label: 'report_actions',
            params: {
              pagination: false
            }
          }).callbacks((success) => {
            let actions = {};
            success.result.rows.map((item) => {
              actions[item.id] = item
            });
            this.setState({
              actions: actions
            });
      
            if (this.props.action_id) {
              this.setState({
                actionSchema: schema_to_field(actions[this.props.data.plugin_id].validation_config || {})
              })
            }
      
          })
            .connect(props.domains.settings);
      
      
          this.post_unrecon_action = RESTExecutor.post().config({
            label: 'report_actions',
          }).callbacks((success) => {
            message.success("Action Added Successfully");
            typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()
      
          }, (error) => {
            showErrorInNotification(error)
          }).connect(props.domains.reports);
      
          this.patch_unrecon_action = RESTExecutor.patch().config({
            label: 'report_actions_detail',
            params:{}
          }).callbacks((success) => {
            message.success("Action Modified Successfully");
            typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()
      
      
          }, (error) => {
            showErrorInNotification(error)
              }).connect(props.domains.reports);
      
    }


    handlePostPatch = () => {
        if (this.state.edit_id) {
          this.patch_unrecon_action.config({
              params:{
                  config_id:this.props.config_id,
                  action_id:this.state.edit_id
              }
          })
          .execute(
              {...this.state.form_data,
                config_id: this.props.config_id
            })
        } else {
          this.post_unrecon_action.forId(this.props.config_id).execute({...this.state.form_data
        });
        }
      }
    
      scheduleUpdater = ({ key, value }) => {
        let form_data = this.state.form_data;
        if (!form_data.schedule) {
          form_data['schedule'] = {}
        }
        form_data.schedule[key] = value;
        this.setState({
          form_data: form_data
        })
      }
    
    

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
          newData[valueKey] = value;
        }
        if (appendObj) {
          Object.assign(newData, appendObj)
        }
        // console.log(newData);
        this.setState({
          [stateKey]: newData
        }, () => {
          typeof callback === 'function' && callback()
        })
      }
    
      render() {
        const { actions, form_data, edit_id, source_id } = this.state;
       let schedule = form_data.schedule || {};
   
       // console.log("days list",day_list)
       return (
         <div>
   
           <div style={{
             display: 'flex',
             flexDirection: 'column',
           }}>
             <Row type='flex' justify='center' style={{
               flex: 1
             }}>
               <div style={{
                 display: 'flex',
                 flexDirection: 'column',
                 width: 'fit-content',
                 textAlign: 'right',
                 justifyContent: 'center'
               }}
               >
                 <span>
                   Action Name: &nbsp; <Input
                     placeholder={"Action  Name"}
                     onChange={(e) => {
                       this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                     }}
                     value={form_data.name}
                     style={{
                       width: 300
                     }} >
                   </Input>
                 </span>
                 {/* <br></br>
                 <span>
                   Cron Description: &nbsp; <Input.TextArea
                     placeholder={"Cron  Description"}
                     onChange={(e) => {
                       this.stateUpdater({ stateKey: 'form_data', valueKey: 'description', value: e.target.value })
                     }}
                     value={form_data.description}
                     style={{
                       width: 300
                     }} >
                   </Input.TextArea>
                 </span> */}
                 <br></br>
                 {/* <span>
                               Action Order: &nbsp; <Input
                                   placeholder={"Action  Order"}
                                   onChange={(e) => {
                                       this.stateUpdater({ stateKey: 'form_data', valueKey: 'order', value: e.target.value })
                                   }}
                                   value={form_data.order}
                                   style={{
                                       width: 300
                                   }} >
                               </Input>
                           </span>
                           <br></br> */}
                 <span>Action: <Select style={{ width: 300 }}
                   placeholder="Action"
                   filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                   showSearch
                   value={form_data.plugin_id}
                   onChange={(value) => {
                     this.stateUpdater({
                       stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                         this.stateUpdater({ stateKey: 'form_data', valueKey: 'plugin_params', value: {} })
                       }
                     });
                     this.setState({
                       actionSchema: schema_to_field(actions[value].validation_config || {})
                     })
                   }}
   
   
                 >
                   {
                     Object.keys(actions).map((key, index) => {
                       let item = actions[key];
                       return <Select.Option value={item.id} key={item.id}>
                         {item.name}
                       </Select.Option>
                     })
                   }
   
                 </Select>
                 </span>
               </div>
             </Row>
             <br></br>
             {this.state.actionSchema.length > 0 ?
               <React.Fragment>
                 <Divider style={{
                   marginTop: 8,
                   marginBottom: 8
                 }} />
   
                 <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
                 <Form
                   hideTitle
                   forCreate={true}
                   initialData={form_data.plugin_params || {}}
                   submitted={this.state.submitted}
                   onChange={(data) => {
                     console.log("Changes", data);
                     this.stateUpdater({
                       stateKey: 'form_data',
                       valueKey: 'plugin_params',
                       value: data,
                     });
                   }}
                   fields={this.state.actionSchema}
                   submitting={{}}
                   errorMessage={{}}
                   validationErrors={{}}
                 />
               </React.Fragment>
               : null}
   
             {/* <React.Fragment>
               <Divider style={{
               marginTop: 8,
               marginBottom: 8
             }} />
             <Title style={{ margin: 0 }} level={4} type='secondary'>Schedule</Title>
             <ScheduleChanger 
             schedule={schedule}
             onChange={(schedule)=>{
               console.log("Schedule is",schedule)
               this.stateUpdater({ stateKey: 'form_data', valueKey: 'schedule', value:schedule })
   
             }}
             />
             </React.Fragment> */}
   
   
             <br></br>
             <br></br>
             <Row type='flex' justify='space-between'>
               <div>
                 <Button type='link' style={{ color: 'red' }} onClick={() => {
                   typeof this.props.onClose === 'function' && this.props.onClose()
                 }}>Cancel</Button>
               </div>
               <div>
                 <Button type='primary' onClick={() => {
                   this.handlePostPatch()
                 }}>Submit</Button>
               </div>
             </Row>
   
   
           </div>
   
         </div>
       );
     }
   
     componentDidMount() {
       this.list_actions.execute()
     }
   
   
     componentDidUpdate = (prevProps) => {
       if (this.props.action_id !== prevProps.action_id || this.props.data !== prevProps.data) {
         this.list_actions.execute()
         this.setState({
           edit_id: this.props.action_id,
           form_data: this.props.data||{}
         })
       };
   
     }
}

export default withDomains(ReportActionsAddEdit,"settings","reports");
